import React from 'react'
import { Grow, Paper } from '@mui/material'
import { TypewriterText } from '@/shared/components/Typewriter/TypewriterText'
import { ANIMATION_DURATION } from '@/constants/register.contants'

export const ThankYouMessage: React.FC<ThanksMessageProps> = ({ userName }) => {
  return (
    <Grow in={true} timeout={ANIMATION_DURATION}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 4,
          borderColor: 'divider',
          borderStyle: 'solid',
        }}
      >
        <TypewriterText
          delay={5}
          text={`Thank you for sharing your details and your acknowledgement, ${userName}! 🙌 We have captured your details, and you’re all set. We’re excited to have you on board! Stay tuned for updates! 🚀`}
          variant="body1"
        />
      </Paper>
    </Grow>
  )
}
